export enum ELedgerType {
  BOOKING_LEDGER = 'BOOKING_LEDGER',
  DEPOSIT_ACCOUNT = 'DEPOSIT_ACCOUNT',
}
